import { EnvironmentInjector, ApplicationRef, Injector } from '@angular/core';
import { createComponent } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LLMActionsComponent } from '../components/_common/llm-actions/llm-actions.component';

export class LLMActionsInjectionController {
  private llmComponentRef: any = null;
  private mutationObserver: MutationObserver | null = null;

  constructor(
    private selector: string,
    private config: {
      environmentInjector: EnvironmentInjector;
      appRef: ApplicationRef;
      injector: Injector;
      router: Router;
      route: ActivatedRoute;
    }
  ) {}

  inject(): void {
    if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') {
      return;
    }
    const targetElement = document.querySelector(this.selector);

    if (targetElement && !targetElement.querySelector('llm-actions')) {
      this.createAndInjectComponent(targetElement);
      return;
    }

    if (!targetElement) {
      this.waitForElement();
    }
  }

  remove(): void {
    this.disconnectObserver();
    if (this.llmComponentRef) {
      this.config.appRef.detachView(this.llmComponentRef.hostView);
      this.llmComponentRef.destroy();
      this.llmComponentRef = null;
    }
  }

  isInjected(): boolean {
    return this.llmComponentRef !== null;
  }

  private waitForElement(): void {
    this.mutationObserver = new MutationObserver(() => {
      const targetElement = document.querySelector(this.selector);
      if (targetElement && !targetElement.querySelector('llm-actions')) {
        this.createAndInjectComponent(targetElement);
        this.disconnectObserver();
      }
    });

    this.mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  private createAndInjectComponent(targetElement: Element): void {
    const customInjector = Injector.create({
      providers: [
        { provide: ActivatedRoute, useValue: this.config.route },
        { provide: Router, useValue: this.config.router },
      ],
      parent: this.config.injector,
    });

    this.llmComponentRef = createComponent(LLMActionsComponent, {
      environmentInjector: this.config.environmentInjector,
      elementInjector: customInjector,
    });

    this.config.appRef.attachView(this.llmComponentRef.hostView);
    targetElement.appendChild(this.llmComponentRef.location.nativeElement);
  }

  private disconnectObserver(): void {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  }
}
